import React, { FC, useState } from "react";
import facebookSvg from "images/Facebook.svg";
import twitterSvg from "images/Twitter.svg";
import googleSvg from "images/Google.svg";
import { Helmet } from "react-helmet-async";
import Input from "shared/Input/Input";
import { Link, useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useAuth } from "../../contexts/AuthContext";
import { useTranslation } from "react-i18next";

export interface PageLoginProps {
  className?: string;
}

const loginSocials = [
  {
    nameKey: "socialLogin.facebook", // Cambia `name` a `nameKey` para la clave de traducción
    href: "#",
    icon: facebookSvg,
  },
  {
    nameKey: "socialLogin.twitter",
    href: "#",
    icon: twitterSvg,
  },
  {
    nameKey: "socialLogin.google",
    href: "#",
    icon: googleSvg,
  },
];

const PageLogin: FC<PageLoginProps> = ({ className = "" }) => {
  const { t } = useTranslation("pageLogin");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string>("");

  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  
    if (email === "1234@1234.com" && password === "1234") {
      login(); // Ejecuta la función de inicio de sesión
  
      // Verifica si hay una redirección pendiente
      const redirectAfterLogin = localStorage.getItem("redirectAfterLogin");
      if (redirectAfterLogin) {
        localStorage.removeItem("redirectAfterLogin"); // Limpia el valor después de usarlo
        navigate(redirectAfterLogin); // Redirige al destino deseado
      } else {
        navigate("/"); // Si no hay redirección, lleva a la página de inicio
      }
    } else {
      setError(t("errorMessage"));
    }
  };

  return (
    <div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
      <Helmet>
        <title>{t("title")}</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <h2 className="my-20 flex items-center text-3xl md:text-5xl font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          {t("heading")}
        </h2>
        <div className="max-w-md mx-auto space-y-6">
          <div className="grid gap-3">
            {loginSocials.map((item, index) => (
              <a
                key={index}
                href={item.href}
                className="nc-will-change-transform flex w-full rounded-lg bg-primary-50 dark:bg-neutral-800 px-4 py-3 transform transition-transform hover:translate-y-[-2px]"
              >
                <img className="flex-shrink-0" src={item.icon} alt={t(item.nameKey)} />
                <h3 className="flex-grow text-center text-sm font-medium text-neutral-700 dark:text-neutral-300">
                  {t(item.nameKey)}
                </h3>
              </a>
            ))}
          </div>
          <div className="relative text-center">
            <span className="relative z-10 inline-block px-4 font-medium text-sm bg-white dark:text-neutral-400 dark:bg-neutral-900">
              {t("or")}
            </span>
            <div className="absolute left-0 w-full top-1/2 transform -translate-y-1/2 border dark:border-neutral-800"></div>
          </div>
          <form className="grid gap-6" onSubmit={handleSubmit}>
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200">
                {t("emailLabel")}
              </span>
              <Input
                type="email"
                placeholder={t("emailPlaceholder")}
                className="mt-1"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            <label className="block">
              <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                {t("passwordLabel")}
                <Link to="/forgot-pass" className="text-sm">
                  {t("forgotPassword")}
                </Link>
              </span>
              <Input
                type="password"
                className="mt-1"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
            {error && <p style={{ color: "red" }}>{error}</p>}
            <ButtonPrimary type="submit">{t("continueButton")}</ButtonPrimary>
          </form>
          <span className="block text-center text-neutral-700 dark:text-neutral-300">
            {t("newUser")} <Link to="/signup">{t("createAccount")}</Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default PageLogin;
